import { RootState } from '../stores'

export const selectUser = (state: RootState) => state.user.user
export const selectUserLoading = (state: RootState) => state.user.isLoading
export const selectUserError = (state: RootState) => state.user.error
export const selectUserName = (state: RootState) => state.user.user?.name
export const selectUserEmail = (state: RootState) => state.user.user?.email
export const selectUserRole = (state: RootState) => state.user.user?.role
export const selectUserOrganizations = (state: RootState) => state.user.user?.organizations
export const selectUserMeasure = (state: RootState) => state.user.user?.measure
export const selectUserLanguage = (state: RootState) => state.user.user?.language
export const selectUserTimeZone = (state: RootState) => state.user.user?.timeZone
export const selectUserGmtTimeZone = (state: RootState) => state.user.user?.gmtTimeZone
export const selectUserAvatar = (state: RootState) => state.user.user?.avatar
export const selectIsSuperUserOfAnyOrganization = (state: RootState) => state.user.user?.isSuperUserOfAnyOrganization

export const selectUserPermissions = (state: RootState) => state.user.permissions
export const selectPermissionLoading = (state: RootState) => state.user.permissions.isLoading
export const selectInterfaces = (state: RootState) => state.user.permissions.interfaces
export const selectInterfacesByOrganization = (state: RootState) => state.user.permissions.interfacesByOrganization
export const selectIsViewOnly = (state: RootState) => state.user.permissions.isViewOnly
export const selectPermissionLastFetched = (state: RootState) => state.user.permissions.lastFetched

export const selectShouldRefreshPermissions = (state: RootState) => {
  const lastFetched = state.user.permissions.lastFetched
  const CACHE_DURATION = 5 * 60 * 1000
  return !lastFetched || (Date.now() - lastFetched > CACHE_DURATION)
}